<template>
    <form @submit.prevent="onSubmit" class="form-horizontal form-material">
        <div class="card text-white bg-danger" v-if="Object.keys(errors).length">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4></div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{errors}}</p>
                <p v-else class="card-text" v-for="(error, key) in errors" :key="key">
                    {{key}}:{{error}}
                </p>
            </div>
        </div>

        <div class="form-group" v-if="type==='clone'">
            <h4>Create a clone of this mail list</h4>
        </div>
        <div class="form-group">
            <label :for="'emailList_name_' + type" class="mt-1">{{inputLabel}}</label>
            <input v-model="emailList.name" type="text" class="form-control" :id="'emailList_name_' + type"
                   name="emailList_name">
            <div v-if="$v.emailList.name.$error">
                <div class="text-danger" v-if="!$v.emailList.name.required">Name is required.</div>
                <div class="text-danger" v-if="!$v.emailList.name.minLength">Name must have at least
                    {{$v.emailList.name.$params.minLength.min }} characters.
                </div>
            </div>
        </div>

        <div class="mb-4">
            <label>Category:</label>
            <treeselect placeholder="Search by category"
                        v-model="emailList.category.id"
                        :multiple="false"
                        :options="categoryList"
                        :load-options="loadCategoryList"
            />
            <div v-if="$v.emailList.category.id.$error">
                <div class="text-danger" v-if="!$v.emailList.category.id.required">Category is required.</div>
            </div>
        </div>

        <div class="mb-4" v-if="type==='edit'">
            <label>Users:</label>
            <treeselect v-model="emailList.users" placeholder="Select User"
                        :options="userSelect"
                        :load-options="loadUsers"
                        :multiple="true"
                        value-format="object"/>
        </div>

        <div class="form-group text-center p-b-5 p-t-20">
            <div class="col-xs-12">
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" v-show="!submitting">
                    {{type === 'clone' ? 'Clone' : 'Save'}}
                </button>
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" disabled
                        v-show="submitting">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import {required, minLength} from 'vuelidate/lib/validators';
    import EmailListService from '../../services/EmailListService';
    import CategoryService from '../../services/CategoryService';
    import Treeselect from '@riophae/vue-treeselect';
    import UserService from '../../services/UserService';

    export default {
        name: 'EmailListForm',
        props: ['id', 'type'],
        components: {
            Treeselect
        },
        data() {
            return {
                emailList: {
                    id: null,
                    name: null,
                    category: {id: null},
                    failedEmailsUrl: null,
                    users: []
                },
                userSelect: null,
                categoryList: null,
                errors: {},
                submitting: false,
                inputLabel: 'Name:'
            }
        },
        mounted() {
            if (this.id && this.type === 'edit') {
                EmailListService.getEmailListById(this.id).then(response => {
                    this.emailList = response.data;
                    this.$emit('setEmailList', this.emailList);
                    this.$emit('hidePreloader', true);
                });
            }
            if (this.type === 'clone') {
                this.inputLabel = 'Name of new email list:'
            }
        },
        validations: {
            emailList: {
                name: {required, minLength: minLength(1)},
                category: {id: {required}}
            }
        },
        methods: {
            loadUsers({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userSelect = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            loadCategoryList({callback}) {
                CategoryService.getCategorySelect().then(response => {
                    this.categoryList = response.data['hydra:member'].map(category => {
                        return {id: category.id, label: category.name}
                    });
                    callback();
                });
            },
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) return;
                this.submitting = true;

                let postData = Object.assign({}, this.emailList);

                this.errors = {};
                let submitMethod = null;
                if (!this.id) {
                    submitMethod = EmailListService.createEmailList(JSON.stringify(postData));
                } else if (this.type === 'clone') {
                    postData.id = this.id;
                    submitMethod = EmailListService.cloneEmailList(JSON.stringify(postData));
                } else {
                    submitMethod = EmailListService.updateEmailList(this.id, JSON.stringify(postData));
                }

                submitMethod.then(response => {
                    this.submitting = false;
                    if (response.data.error !== undefined) {
                        this.errors = response.data.error;
                    } else {
                        if (this.type === 'clone' || !this.id) {
                            this.$router.push({name: 'emailListManage', params: {id: response.data.id}});
                        } else {
                            this.$router.push({name: 'emailLists'});
                        }
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
